import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const FriendReferralSettings = lazy(
    () => import('../components/FriendReferralSettings')
);

const friendReferralSettings: RouteObject = {
    path: 'settings/modules/friend-referral',
    element: <FriendReferralSettings />,
};

export default friendReferralSettings;
